import styled from "styled-components";

const TextArea = styled.textarea`
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  width: 100%;
  background-color: transparent;
  color: inherit;
`;

export default TextArea;
